export const academicTitles = [
  { idAcademicTitle: 1, AcademicTitle: 'kein' } as const,
  { idAcademicTitle: 2, AcademicTitle: 'Dr.' } as const,
  { idAcademicTitle: 3, AcademicTitle: 'Prof.' } as const,
  { idAcademicTitle: 4, AcademicTitle: 'Prof. Dr.' } as const,
];

export type IAcademicTitle = (typeof academicTitles)[number];
export type IdAcademicTitle = IAcademicTitle['idAcademicTitle'];

export function getAcademicTitle(
  idAcademicTitle: number | null
): string | undefined {
  const title = academicTitles.find(
    title => title.idAcademicTitle === idAcademicTitle
  )?.AcademicTitle;

  return title;
}

export function getAcademicTitleSafe(idAcademicTitle: IdAcademicTitle): string {
  const title = academicTitles.find(
    title => title.idAcademicTitle === idAcademicTitle
  )?.AcademicTitle;

  if (!title) {
    throw new Error(`Invalid academic title ID: ${idAcademicTitle}`);
  }

  return title;
}

export const isAcademicTitleId = (
  idAcademicTitle: number
): idAcademicTitle is IdAcademicTitle => {
  return academicTitles.some(
    title => title.idAcademicTitle === idAcademicTitle
  );
};
